module.exports = __webpack_public_path__ + "img/spartan-roof-replacement-waterproofing-06-large.852a5b81.jpg";